// @ts-nocheck
import emptyForm from "@store/Framework/Store/Foundation/Components/Form/Handlers/EmptyForm";
import { useDispatch } from "react-redux";

export default (formId: string) => {
    const dispatch = useDispatch();
    return () => dispatch(emptyForm({ formId }));
};
